"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspace = void 0;
const store_1 = require("@app/store");
const useWorkspace = () => {
    const workspace = (0, store_1.useRootSelector)(state => state.workspaces.find(ws => ws.id === state.workspaceId));
    return workspace;
};
exports.useWorkspace = useWorkspace;
